export enum AppCategory {
  None = 0,
  Dashboard = 1,
  WorkOrders = 2,
  Invoices = 3,
  Quotes = 4,
    Equipment = 5,
    Contracts = 100,
    Jobs = 101,
    MainJobs = 102,
    ChangeOrders = 103,
    ManufacturerWarranty = 104,
    PostWarranty = 105
}
